module.exports = __webpack_public_path__ + "img/koa.0a02fec6.svg";